export class StripeValidationError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'StripeValidationError';
  }
}
